module.exports = __webpack_public_path__ + "img/android5bg3.283ea073.png";